export const USER_LOGIN = "USER_LOGIN";
export const GET_PROFILE = "GET_PROFILE";
export const AUTHENTICATION = "AUTHENTICATION";
export const GET_DASHBOARD_COUNT = "GET_DASHBOARD_COUNT";
